"use client";
import React, { FormEvent, useState } from "react";
import type { CTASection } from "@/types/sections/cta";
import { getBackgroundStyle, paddingMap } from "@/lib/background";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import Image from "next/image";

export default function CtaForm({ data }: CTASection) {
  const {
    title,
    subtitle,
    background,
    form,
    alignment = "center",
    padding = "xl",
  } = data || {};

  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const bgStyle = getBackgroundStyle(background);

  const textAlignMap = {
    left: "text-left",
    center: "text-center",
    right: "text-right",
  };

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <section
      className={`${paddingMap[padding] || "py-20 px-8"} ${
        textAlignMap[alignment] || "text-center"
      } relative`}
      style={bgStyle}
    >
      {background?.type === "image" && background?.value && (
        <Image
          src={background.value}
          alt={title || subtitle || ""}
          fill
          priority
          className="object-cover object-center z-0"
        />
      )}
      <div className="max-w-xl mx-auto relative z-10">
        {title && <h2 className="text-3xl font-bold mb-3">{title}</h2>}
        {subtitle && (
          <p className="text-lg text-muted-foreground mb-6">{subtitle}</p>
        )}

        {form?.enabled && (
          <form
            onSubmit={onSubmit}
            className="flex flex-col sm:flex-row gap-4 justify-center items-center"
          >
            <Input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={form.placeholder || "Enter your email"}
              className="w-full sm:w-auto flex-1"
            />
            <Button type="submit" className="min-w-[140px]">
              {submitted ? "Submitted!" : form.buttonText || "Subscribe"}
            </Button>
          </form>
        )}
      </div>
    </section>
  );
}
